import { render, staticRenderFns } from "./AdminEducationPartner.vue?vue&type=template&id=248e1f0a&"
import script from "./AdminEducationPartner.vue?vue&type=script&lang=js&"
export * from "./AdminEducationPartner.vue?vue&type=script&lang=js&"
import style0 from "./AdminEducationPartner.vue?vue&type=style&index=0&id=248e1f0a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports